/** 사이드바 «관리자 메뉴» 표시 여부 (관리자·매니저 계정용 LS) */

const STORAGE_KEY_PREFIX = 'cp.admin.sidebar-menu.visible.v1';

export const ADMIN_SIDEBAR_MENU_VISIBLE_CHANGED_EVENT = 'cp-admin-sidebar-menu-visible-changed';

function storageKey(email: string): string {
  const e = email.trim().toLowerCase();
  return e ? `${STORAGE_KEY_PREFIX}.${e}` : STORAGE_KEY_PREFIX;
}

/** 미설정·오류 시 기본값: 표시(ON) */
export function readAdminSidebarMenuVisiblePref(email: string): boolean {
  if (typeof window === 'undefined') return true;
  try {
    const raw = window.localStorage.getItem(storageKey(email));
    if (raw == null) return true;
    return raw === '1';
  } catch {
    return true;
  }
}

export function writeAdminSidebarMenuVisiblePref(email: string, visible: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey(email), visible ? '1' : '0');
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(
      new CustomEvent(ADMIN_SIDEBAR_MENU_VISIBLE_CHANGED_EVENT, {
        detail: { email: email.trim().toLowerCase(), visible },
      })
    );
  } catch {
    /* ignore */
  }
}
